var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from "prop-types";

import { Widget, WidgetHeader, WidgetBody, WidgetFooter, WidgetTitle, WidgetSpinner } from "../";
import { Chart, ChartTooltip, FormatMetric } from "../";

import { getGaDataByMetrics } from "../../resources/functions/";

import Color from 'color';
import _ from "lodash";
import moment from "moment";

import "./AnalyticsReportRegVsPub.scss";

var AnalyticsReportRegVsPub = (_temp2 = _class = function (_Component) {
    _inherits(AnalyticsReportRegVsPub, _Component);

    function AnalyticsReportRegVsPub() {
        var _temp, _this, _ret;

        _classCallCheck(this, AnalyticsReportRegVsPub);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            style: {},
            colors: ["white", "rgba(255,255,255,0.25)"],
            data: undefined,
            chartData: [{
                "id": "dm:published",
                "label": "Publisert",
                "value": 0
            }, {
                "id": "dm:unpublished",
                "label": "Ikke publisert",
                "value": 1
            }],
            loading: true
        }, _this.componentDidUpdate = function (prevProps, prevState) {
            if (prevProps.report !== _this.props.report) {
                _this.getReport();
            }

            if (prevProps.theme !== _this.props.theme || prevProps.backgroundColor !== _this.props.backgroundColor) {
                _this.getColors();
            }

            if (prevState.data !== _this.state.data) {
                _this.getChartData();
                _this.getListData();
            }
        }, _this.getColors = function () {
            var _this$props = _this.props,
                backgroundColor = _this$props.backgroundColor,
                theme = _this$props.theme;


            backgroundColor = Color(backgroundColor);

            var color = void 0;

            if (theme) {
                backgroundColor = "white";
                color = theme && theme.primaryColor || "black";
            } else if (backgroundColor.isDark()) {
                color = "white";
            } else {
                color = "black";
            }

            var style = {
                backgroundColor: backgroundColor,
                color: color

                // colors

            };var colors = [];

            if (color === "white") {
                colors = ["white", "rgba(255,255,255,.25)"];
            } else {
                colors = [color, "rgba(0,0,0,.125)"];
            }

            _this.setState({
                style: style,
                colors: colors
            });
        }, _this.getReport = function () {
            var report = _this.props.report;

            // set state

            _this.setState({
                loading: true
            });

            if (!report) {
                return false;
            }

            // load data

            var data = getGaDataByMetrics(report);

            if (!data) {
                return false;
            }

            _this.setState({
                loading: false,
                data: data
            });
        }, _this.getChartData = function () {
            var _this$state = _this.state,
                data = _this$state.data,
                colors = _this$state.colors;


            if (!data) {
                return false;
            }

            var total = data["primus:total"] && data["primus:total"].total || 0;
            var published = data["dm:published"] && data["dm:published"].total || 0;
            var unpublished = data["dm:unpublished"] && data["dm:unpublished"].total || 0;

            var chartData = [{
                "id": "dm:published",
                "label": "Publisert",
                "value": published
            }, {
                "id": "dm:unpublished",
                "label": "Ikke publisert",
                "value": unpublished
            }];

            _this.setState({
                summary: {
                    total: total,
                    published: published,
                    unpublished: unpublished
                },
                chartData: chartData
            });
        }, _this.getListData = function () {
            var data = _this.state.data;


            if (!data) {
                return false;
            }

            var total = data["primus:total"] && data["primus:total"].data || [];
            var published = data["dm:published"] && data["dm:published"].data || [];
            var unpublished = data["dm:unpublished"] && data["dm:unpublished"].data || [];

            var listData = [];

            total.map(function (row, index) {
                var data = row.data,
                    total = row.total;

                var label = data[0]["ga:objectType"];

                var listItem = {
                    "label": label,
                    "total": total,
                    "published": published[index].total,
                    "unpublished": unpublished[index].total
                };

                if (total) {
                    listData.push(listItem);
                }
            });

            _this.setState({
                listData: listData
            });
        }, _this.renderTooltip = function (props) {
            var data = props.data;


            return React.createElement(
                ChartTooltip,
                null,
                React.createElement(
                    "h2",
                    { className: "admin-tooltip__title" },
                    "Publisert vs. registrert"
                ),
                React.createElement(
                    "ul",
                    null,
                    React.createElement(
                        "li",
                        null,
                        React.createElement("div", { className: "admin-tooltip__chip", style: { backgroundColor: "white" } }),
                        React.createElement(
                            "b",
                            { className: "admin-tooltip__value" },
                            "Publisert"
                        ),
                        React.createElement(
                            "i",
                            { className: "admin-tooltip__value" },
                            React.createElement(FormatMetric, { type: "INTEGER", value: 1000 })
                        )
                    ),
                    React.createElement(
                        "li",
                        null,
                        React.createElement("div", { className: "admin-tooltip__chip", style: { backgroundColor: "rgba(255,255,255,0.25" } }),
                        React.createElement(
                            "b",
                            { className: "admin-tooltip__value" },
                            "Registert"
                        ),
                        React.createElement(
                            "i",
                            { className: "admin-tooltip__value" },
                            React.createElement(FormatMetric, { type: "INTEGER", value: 50 })
                        )
                    )
                )
            );
        }, _this.renderChart = function () {
            var chartTitle = _this.props.chartTitle;
            var _this$state2 = _this.state,
                chartData = _this$state2.chartData,
                colors = _this$state2.colors;


            return React.createElement(Chart, { type: "pie", data: chartData, colors: colors, enableSlicesLabels: false });
        }, _this.renderListItem = function (item, index) {
            var label = item.label,
                total = item.total,
                unpublished = item.unpublished,
                published = item.published;


            var value = published;
            var percentage = published / total * 100;

            var style = _this.state.style;


            var pctStyle = {
                backgroundColor: style && style.color || "black",
                width: percentage + "%"
            };

            return React.createElement(
                "li",
                { className: "list-item", key: index },
                React.createElement(
                    "b",
                    { className: "list-item__label" },
                    item['label']
                ),
                React.createElement(
                    "i",
                    { className: "sparkline" },
                    React.createElement("i", { className: "sparkline__bar", style: pctStyle })
                ),
                React.createElement(
                    "b",
                    { className: "list-item__value" },
                    React.createElement(FormatMetric, { type: "PERCENT", value: percentage, decimals: "1" })
                )
            );
        }, _this.renderDetails = function () {
            var listTitle = _this.props.listTitle;
            var listData = _this.state.listData;


            if (!listData) {
                return false;
            }

            return React.createElement(
                "section",
                { className: "details" },
                React.createElement(
                    "ul",
                    { className: "list" },
                    listData.map(_this.renderListItem)
                )
            );
        }, _this.renderLegend = function () {
            var _this$state3 = _this.state,
                summary = _this$state3.summary,
                colors = _this$state3.colors;


            if (!summary) {
                return false;
            }

            var total = summary.total,
                published = summary.published,
                unpublished = summary.unpublished;


            return React.createElement(
                "section",
                { className: "admin-legend" },
                React.createElement(
                    "ul",
                    null,
                    React.createElement(
                        "li",
                        null,
                        React.createElement("div", { className: "admin-legend__chip", style: { backgroundColor: colors[1] } }),
                        React.createElement(
                            "b",
                            { className: "admin-legend__label" },
                            "Primus"
                        ),
                        React.createElement(
                            "i",
                            { className: "admin-legend__value" },
                            React.createElement(FormatMetric, { type: "INTEGER", value: total })
                        )
                    ),
                    React.createElement(
                        "li",
                        null,
                        React.createElement("div", { className: "admin-legend__chip", style: { backgroundColor: colors[0] } }),
                        React.createElement(
                            "b",
                            { className: "admin-legend__label" },
                            "DigitaltMuseum"
                        ),
                        React.createElement(
                            "i",
                            { className: "admin-legend__value" },
                            React.createElement(FormatMetric, { type: "INTEGER", value: published })
                        )
                    )
                )
            );
        }, _this.renderSummary = function () {
            var _this$props2 = _this.props,
                title = _this$props2.title,
                loadingTitle = _this$props2.loadingTitle;
            var _this$state4 = _this.state,
                summary = _this$state4.summary,
                colors = _this$state4.colors,
                style = _this$state4.style;


            var loading = _this.state.loading || _this.props.loading;

            if (loading || !summary) {

                return React.createElement(
                    "section",
                    { className: "summary" },
                    React.createElement(
                        "h1",
                        { className: "summary__title" },
                        loadingTitle
                    ),
                    React.createElement(WidgetSpinner, { style: style })
                );
            }

            var total = summary.total,
                published = summary.published,
                unpublished = summary.unpublished;


            var percentage = published / total * 100;

            return React.createElement(
                "section",
                { className: "summary" },
                React.createElement(
                    "h1",
                    { className: "summary__title" },
                    title
                ),
                React.createElement(
                    "h2",
                    { className: "summary__value" },
                    React.createElement(FormatMetric, { type: "PERCENT", value: percentage, decimals: "0" })
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    AnalyticsReportRegVsPub.prototype.componentDidMount = function componentDidMount() {
        this.getReport();
        this.getColors();
    };

    AnalyticsReportRegVsPub.prototype.render = function render() {
        var style = this.state.style;


        return React.createElement(
            Widget,
            _extends({}, this.props, { style: style }),
            React.createElement(
                WidgetHeader,
                null,
                this.renderSummary(),
                this.renderChart(),
                this.renderLegend()
            ),
            React.createElement(
                WidgetFooter,
                null,
                this.renderDetails()
            )
        );
    };

    return AnalyticsReportRegVsPub;
}(Component), _class.defaultProps = {
    backgroundColor: "white",
    widgetType: "analytics-reg-vs-pub",
    widgetSize: "1:1",

    loadingTitle: "Primus vs. DigitaltMuseum",
    title: "Primus vs. DigitaltMuseum",
    listTitle: "Object types"
}, _temp2);
AnalyticsReportRegVsPub.propTypes = process.env.NODE_ENV !== "production" ? {
    title: PropTypes.string,
    listTitle: PropTypes.string,
    loadingTitle: PropTypes.string
} : {};


export default AnalyticsReportRegVsPub;